import { SetDataRecordRequestInterface } from '@elearning-platform/api-types/interfaces';

import { api } from '../api';

export const setLegalFormDataRecordByReviewer: (formAttemptId: number, recordData: SetDataRecordRequestInterface) => Promise<void> = (
  formAttemptId: number, recordData: SetDataRecordRequestInterface
): Promise<void> => api.post(
  `legal-forms-administration/data/${formAttemptId}`, recordData
);
